<template>
    <div style="padding-bottom: 40px">{{title}}</div>
    <DxChart
                :data-source="this.statistics"
                :rotated="true" width="500" height="450">
        <DxArgumentAxis>
            <DxLabel template="axeTemplate"/>
        </DxArgumentAxis>
        <template #axeTemplate="{data}">
            <svg overflow="visible">
                <foreignObject height="40px" width="200px">
                    <div class="template-text">
                        {{data.valueText}}
                    </div>
                </foreignObject>
            </svg>
        </template>
        <DxValueAxis :visible="false"
                :auto-breaks-enabled="false"
                :max-auto-break-count="3" :grid={visible:false}>
            <DxLabel :visible="false"/>
            <DxBreakStyle
                    :color="'grey'"
                    :line="'straight'"
                    :width="5"/>
        </DxValueAxis>
        <DxSeries type="bar" :minBarSize="5" value-field="Value" argument-field="Name" color="#70b92f">
            <DxLabel :visible="true" position="top" :font="{size:14}"/>
        </DxSeries>
        <DxLegend :visible="false"/>
    </DxChart>
</template>
<script>

import {
    DxChart,
    DxSeries,
    DxLabel,
    DxLegend,
    DxArgumentAxis,
    DxValueAxis, 
    DxBreakStyle,
} from "devextreme-vue/chart";
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        statistics: {
            type: Array,
            required: true 
        }
    },
    components: {
        DxChart,
        DxSeries,
        DxLabel,
        DxLegend,
        DxArgumentAxis,
        DxValueAxis,
        DxBreakStyle,
    },
    data() {
        return {
            labelWidths: []
        }
    },
    updated() {
        if (this.statistics == undefined)
            return;

        const values = this.statistics.map(object => {
            return Number(object.Value);
        });

        let maxValue = Math.max(...values);
        this.statistics.forEach(element => {
            let width = Math.round(Number(element.Value) * 190 / maxValue);
            element.width = width + 60;
        });
    },
};
</script>

<style scoped>

.dx-field {
    margin-bottom: 10px;
}

.dx-field-label {
    width: 200px;
    font-size: 23px;
    color: black;
    text-align: right;
    white-space: normal;
}

.dx-widget {
    font-size: 25px;
}

.dx-textbox.dx-state-readonly {
    border-style: solid;
    border: 2px solid black;
   /* background: rgb(169, 196, 235);*/
}

#DxTextBox1 /deep/ input {
    text-align:right;
}
.template-text {
    fill: #767676;
    font-family: "Segoe UI", "Helvetica Neue", "Trebuchet MS", Verdana, sans-serif;
    font-weight: 400;
    font-size: 13px;
}
</style>